import { render, staticRenderFns } from "./viewTutoriales.vue?vue&type=template&id=53160080&scoped=true"
import script from "./viewTutoriales.vue?vue&type=script&lang=js"
export * from "./viewTutoriales.vue?vue&type=script&lang=js"
import style0 from "./viewTutoriales.vue?vue&type=style&index=0&id=53160080&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53160080",
  null
  
)

export default component.exports